<template>
  <b-tab title="Contacts">
    <div class="bg-extra-light-gray rounded section-title">
      <h6 class="mb-0">Contacts</h6>
      <b-button variant="primary" size="sm" @click="addContact">
        <i class="fa fa-plus"></i>
      </b-button>
    </div>

    <div class="section-body">
      <b-row>
        <b-col>
          <div v-if="contactItems.length">
            <data-card
              v-for="(contact, contactIndex) in contactItems"
              :cardInfo="contact"
              :key="contactIndex"
              @edit-item="editContact(contact)"
              @delete-item="deleteContact(contact)"
            />
          </div>

          <div v-else class="d-flex justify-content-center color-custom-grey">
            No contact information.
          </div>

          <contact-form
            v-if="contactModalShow"
            v-model="contactModalShow"
            @onModify="onModifyAddContact"
            @ok="submitContact"
            :contact="formContact"
            :patientEmail="patientEmail"
            :contacts="contacts"
          >
          </contact-form>
        </b-col>
      </b-row>
    </div>
  </b-tab>
</template>

<script>
import ContactForm from "../PatientContactForm";
import DataCard from "../../controls/DataCard";

export default {
  name: "EocPortalContacts",
  components: {
    ContactForm,
    DataCard
  },
  props: {
    patientId: {
      type: String,
      default: ""
    },
    patientEmail: {
      type: String,
      default: ""
    },
    contacts: {
      type: Array
    }
  },
  data() {
    return {
      formContact: null,
      contactModalShow: false
    };
  },
  methods: {
    addContact() {
      this.formContact = null;
      this.contactModalShow = true;
    },
    editContact(record) {
      this.formContact = {
        itemIndex: record.itemIndex,
        oldEmail: record.data.email,
        ...record.data
      };
      this.contactModalShow = true;
    },
    onModifyAddContact() {
      this.contactModalShow = false;
    },
    deleteContact(record) {
      this.$dialog
        .confirm(
          { title: "Are you sure you want to delete this record?" },
          { view: "confirm-delete" }
        )
        .then(async () => {
          this.contacts.splice(record.itemIndex, 1);
          this.$emit("update:contacts", this.contacts);
        })
        .catch(function() {});
    },
    submitContact(data) {
      if (typeof data.itemIndex == "number") {
        this.contacts.splice(data.itemIndex, 1, data);
      } else {
        this.contacts.push(data);
      }
      this.contactModalShow = false;
      this.$emit("update:contacts", this.contacts);
    },
    buildAddress(item) {
      const arr = [];
      if (item.address) arr.push(item.address);
      if (item.city) arr.push(item.city);
      if (item.state) arr.push(item.state.name);
      if (item.zipCode) arr.push(item.zipCode);
      return arr.join(", ");
    }
  },
  computed: {
    contactItems() {
      return this.contacts.map((item, itemIndex) => {
        const data = {
          itemIndex,
          data: item,
          title: item.name,
          extraData: [
            [
              ...(item.relationship
                ? [`Relationship: ${item.relationship.name}`]
                : []),
              ...(item.phone ? [`Mobile Phone: ${item.phone}`] : []),
              ...(item.email ? [`Email: ${item.email}`] : [])
            ]
          ]
        };

        const address = this.buildAddress(item);
        if (address) {
          data.extraData.push([`Address: ${address}`]);
        }

        return data;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.section-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 63px;
  padding: 1rem;
  margin-top: 15px;
  margin-bottom: 15px;
}
.section-body {
  min-height: 70px;
}
</style>
